/*eslint-disable*/
import React from "react";
import { useState, useEffect} from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import NotificationsConfig from "components/NotificationsConfig/NotificationsConfig.js";

import {Table, Tag, } from 'antd';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Swal from 'sweetalert2';

//import moment from 'moment';
import moment from 'moment-timezone';
import 'moment/locale/es';

import './styles.css';

import { fetchConToken } from "helpers/fetch";

import { useSelector } from 'react-redux';



const translations = {
  en: {
    lDateTime: "Date / Time",
    lMetrics: "Metrics",
    lMessage: "Message",
    lState: "State",
    lNormal: "NORMAL",
    lAlert: "ALERT",
    lSensors: "Sensors",
    lErrorFetch: "Error Fetching Notifications",
    lErrorTask: "Error Fetching Tasks",
    lLatest: "Latest Notifications",
    lConfig: "Notifications Configuration",


  },
  es: {
    lDateTime: "Fecha / Hora",
    lMetrics: "Métricas",
    lMessage: "Mensajes",
    lState: "Estado",
    lNormal: "NORMAL",
    lAlert: "ALERTA",
    lSensors: "Sensores",
    lErrorFetch: "Error Cargando Notificaciones",
    lErrorTask: "Error Cargando Tareas",
    lLatest: "Últimas Notificaciones",
    lConfig: "Configuración de Notificaciones",
  }
};


const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
};

let data = [];
const useStyles = makeStyles(styles);











export default function Notifications() {
  
  const {language} = useSelector( state => state.data); 
  const t = translations[language];


  const columns = [
    {
      title: t.lDateTime,
      dataIndex: 'fecha',
      key: 'fecha',
      render: (text) => <a>{text}</a>,
    },
    {
      title: t.lMetrics,
      dataIndex: 'metrica',
      key: 'metrica',
    },
    {
      title: t.lMessage,
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: t.lState,
      dataIndex: 'estado',
      key: 'estado',
      render: (tag) => (
        <span>
          {tag.map((tag) => {
            let color = 'green';
            let status = 'OK';
            if (tag === 'ok') {
              status = t.lNormal
              color = 'green';
            }
            if (tag === 'crit') {
              status = t.lAlert
              color = 'volcano';
            }
            return (
              <Tag color={color} key={tag}>
                {status.toUpperCase()}
              </Tag>
            );
          })}
        </span>
      ),
    },
    {
      title: t.lSensors,
      key: 'lista_sensores',
      dataIndex: 'lista_sensores',
      render: (tags) => (
        <span>
          {tags.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'loser') {
              color = 'volcano';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </span>
      ),
    },
  /*  {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <a>Invite {record.name}</a>
          <a>Delete</a>
        </Space>
      ),
    }, */
  ];

  const classes = useStyles();
  
  const [loading, setLoading] = useState(false);
  const [notificaciones, setNotificaciones] = useState([]);
  const [config, setConfig] = useState([]);

  const [valuesTemperatura, setValuesTemperatura] = useState({
    active: true, time: '15m', direction: 'up', value1: '10', value2: '',    
  });



  const handleChangeTemperatura = (prop) => (event) => {
    if (prop == "active"){
      setValuesTemperatura({ ...valuesTemperatura, [prop]: event.target.checked });
      console.log("selected prop:", prop, " value: ", event.target.checked );
      return;
    }
    
    setValuesTemperatura({ ...valuesTemperatura, [prop]: event.target.value });
    console.log("selected prop:", prop, " value: ", event.target.value );
    console.log("values:", valuesTemperatura);

  };

  let notifStart ="-1d";
  let notifStop ="now()";
  let mounted = true;
  

  
  const fetchData = async () => {
        
    data = [];

    //Notificaciones lectura:
   
    try {
      
      //const respHist = await fetchConToken( `data?start=`+start+`&stop=`+stop+`&query=`+query+ `&sensors=`+sensors )  //CHANGE START to VARIABLE
      const respNotif = await fetchConToken( `notificaciones?start=`+notifStart+`&stop=`+notifStop )
      const bodyNotif = await respNotif.json();
      
      if( bodyNotif.ok ) {
        if(mounted) {
          //setData(body.data)
          let count=0;
          bodyNotif.data.map((entry)=>{
            let array = entry.lista_sensores.replace('[','').replace(']','').split(",");
            //var array = eval(entry.lista_sensores);
            data.push({key:''+count , fecha: moment.tz(entry.time, "America/Guayaquil").format('ll @ HH:mm'), metrica: entry.metrica , message: entry.message, estado: entry.level , lista_sensores:array,  email: entry.email});
            count++;
            //return {time: entry.time, check_name: entry.check_name,  message: entry.message,  source_measurement: entry.source_measurement , lista_sensores:entry.lista_sensores,  email: entry.email}
            
          
          })
          //console.log("Notif Array: ", data);
          setNotificaciones(data.reverse());
          

        }
      }else{
        Swal.fire('Error 0xN001', t.lErrorFetch, 'error');
      }
      
    } catch (error) {
      Swal.fire('Error 0xN002', t.lErrorFetch, 'error');
    }



    //checks lectura
    let checks=[];
    try {
      const resp = await fetchConToken( `checks` )
      const body = await resp.json();
      
      //console.log("dataAverage:" + body);
     // console.log("checks: ", JSON.stringify(body) );
      
      if( body.ok ) {
          if(mounted) {
            //setAverages(body.data)
            //console.log("Checks", body.checks);
            checks=body.checks;
            
          }
      }else{          
        throw new Error(t.lErrorFetch);    
      }
    } catch (error) {
       console.log(error);
       Swal.fire('Error code:0xN011', t.lErrorFetch, 'error');      
    }



    //tasks lectura
    let configs=[];
    try {
      const respTasks = await fetchConToken( `tasks` )
      const bodyTasks = await respTasks.json();
      
      //console.log("dataAverage:" + body);
      //console.log("tasks: ", JSON.stringify(body) );
      
      if( bodyTasks.ok ) {
          if(mounted) {
            //setAverages(body.data)
            console.log("Tasks", bodyTasks.tasks);
            bodyTasks.tasks.map((task)=>{
              let type = "";
              let check_id = ""; 
              let task_name = "";
              let check="";
              let threshold_value="0";
              let threshold_min="0";
              let threshold_max="0";
              let threshold_type="lesser";
              let factor=1; // para transformar valores de metrica

              task.labels.map((label)=>{
                if (label.name=='name') {
                  
                  //Switch para cada tipo // TODO
                  if ( label.properties.description=="humedad"){
                      type=label.properties.description;
                      factor=1000;
                      task_name="Humedad del Suelo";

                  }
                }
                if (label.name=='check'){
                  check_id=label.properties.description;
                  //console.log("check id inside task", check_id);
                  check = checks.find( e => e.id==check_id);

                  //for additional thresholds neet to iterate /// TODO
                  
                  threshold_type = check.thresholds[0].type;
                  if (threshold_type=="range"){
                    threshold_min = check.thresholds[0].min;
                    threshold_max = check.thresholds[0].max;

                  }
                  threshold_value = check.thresholds[0].value;
                  console.log("Find Check:", check);
                  
                }
              })
              configs.push({type: type, name: task_name, factor: factor, status: task.status, every: task.every, check_id: check_id, threshold_type:threshold_type, threshold_value:threshold_value,threshold_min:threshold_min,threshold_max:threshold_max,  });
              setConfig(configs);
              
              console.log("Configs Array:", configs);


            
            })
           
          }
      }else{          
        throw new Error(t.lErrorTask);    
      }
    } catch (error) {
       console.log(error);
       Swal.fire('Error code:0xT011', t.lErrorTask, 'error');      
    }

    setLoading(false);
  }

  useEffect(() => {
      let mounted = true;
      console.log("Mounted Notifications:");
     
      setLoading(true); 
      fetchData();  
        
      return () => mounted = false;
  }, [])


  
  return (
    
    <div style={{ width: '100%', height: '100%' }}>
    

      {(loading) ? (
                <div className={classes.loading} style={{display: "flex", justifyContent: 'center', alignItems: 'flex-start'}}>
                      <LoadingSpinner />
                </div>
       ):(
        <>
          <Card>
            
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  
                  <div style={{display:'flex', flexDirection:'column',padding:'15px' }}>
                    <h5>{t.lLatest}</h5>
                    <Table
                      columns={columns}
                      pagination={{
                        //pageSizeOptions: ['10', '50', '100'], 
                        //showSizeChanger: true,
                        pageSize: 10,
                        //total:500,
                        
                      }}
                      dataSource={notificaciones}
                      scroll={{
                        y: 240,
                      }}
                  
                      size="small"
                    />
                  
                  </div>
                  
                </GridItem>
                
              </GridContainer>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
                <div style={{display:'flex', flexDirection:'column',padding:'15px', marginTop:'1px' }}>
                    <h5>{t.lConfig}</h5>
                  
                    {config.map((config_item) => {
                      
                      return (
                        <NotificationsConfig key={config_item.type} {...config_item}/>
                      );
                    })}
                    
                    
                    
                </div>
            </CardBody>
          </Card>
        </>
    
       )}; 
       

    </div>
  );
}
